import { Button } from '@mui/material';
import type React from 'react';
import ArrowIcon from './ArrowIcon';

type Props = {
  text: string;
  startIcon?: React.ReactNode;
  arrowIcon?: boolean;
  style?: object;
  disabled?: boolean;
  onClickEvent: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
  loading?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

const BasicButton = ({
  text,
  startIcon,
  arrowIcon,
  style,
  onClickEvent,
  disabled = false,
  className,
  loading,
}: Props) => {
  return (
    <Button
      className={className}
      startIcon={startIcon && startIcon}
      endIcon={arrowIcon && <ArrowIcon color='white' />}
      style={{
        // margin: '40px 0',
        textTransform: 'none',
        padding: '8px 15px',
        borderRadius: '30px',
        backgroundColor: disabled ? '' : '#E73A6E',
        fontWeight: 'bold',
        fontSize: '14px',
        ...style,
      }}
      disabled={disabled}
      loading={loading}
      // biome-ignore lint/complexity/useOptionalChain: <explanation>
      onClick={(event) => onClickEvent && onClickEvent(event)}
      variant='contained'
    >
      {text}
    </Button>
  );
};
export default BasicButton;
